export enum SetupStep {
  SESSION_STRUCTURE = 'session_structure',
  SESSION = 'session',
  ACADEMIC_CALENDAR = 'academic_calendar',
  CLASSROOMS = 'classrooms',
  TERTIARY_FACULTY = 'faculty',
  TERTIARY_DEPARTMENT = 'department',
  TERTIARY_PROGRAMME = 'programme',
}

export const SETUP_STEPS_LABELS: Record<SetupStep, string> = {
  [SetupStep.SESSION_STRUCTURE]: 'Create Session Structure',
  [SetupStep.SESSION]: 'Create Session',
  [SetupStep.ACADEMIC_CALENDAR]: 'Set Academic Calendar',
  [SetupStep.CLASSROOMS]: 'Create Classrooms',
  [SetupStep.TERTIARY_FACULTY]: 'Create Faculties',
  [SetupStep.TERTIARY_DEPARTMENT]: 'Create Departments',
  [SetupStep.TERTIARY_PROGRAMME]: 'Create Programmes',
};
